// Transitions
const transitions = {
  easeIn: '200ms ease-in',
  easeOut: '200ms ease-out',
};

export default transitions;
